import { useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { AppFooter } from './AppFooter';

export const AppShell = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 z-50 bg-black/50 lg:hidden" onClick={() => setMobileOpen(false)} />
      )}
      <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
      <div className="lg:pl-[260px] transition-[padding] duration-200 flex-1 flex flex-col">
        <TopBar onMobileMenu={() => setMobileOpen(true)} />
        <main className="px-4 sm:px-6 lg:px-8 py-4 sm:py-6 max-w-[1400px] flex-1">
          {children}
        </main>
        <AppFooter />
      </div>
    </div>
  );
};
